var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CountrySelect',_vm._b({attrs:{"code":_vm.value,"data-cy":"country-select","data-cy-data":_vm.inputCode,"country-codes-list":_vm.countryCodesList,"order-by-loco":_vm.orderByLoco},on:{"change":(code) => {
            _vm.inputCode = code;
            _vm.$emit('input', code);
        }}},'CountrySelect',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }